import WreckingYard from './WreckingYard';
import { sleepingCityBodyLimitForUserAgent } from './sleepingCityProfile';
import './SleepingCity.css';
import './SleepingCityMobile.css';

/** Verified Sleeping City profile: desktop keeps the 4,000-brick showcase, mobile uses the lighter profile. */
export default function SleepingCity({ onBack }: { onBack: () => void }) {
  const bodyLimit = sleepingCityBodyLimitForUserAgent(navigator.userAgent);

  return (
    <WreckingYard
      onBack={onBack}
      initialStructure="cascade"
      bodyLimit={bodyLimit}
      title="Sleeping City"
      pageClassName="sleeping-city-page"
      hideStructures
      cameraPosition={[18, 11, 16]}
      cameraTarget={[0, 2.2, -1]}
      defaultHeatmap
    />
  );
}
